import { ChevronRight, Flight } from '@mui/icons-material';
import { alpha, Avatar, Box, Button, Card, Typography, useTheme } from '@mui/material';

export const CartCrossSellBanner = () => {

  const theme =  useTheme();

  return (
    <Card>
      <Box
        display="flex"
        p={3}
        justifyContent="space-between"
        alignItems="center"
        alignSelf="stretch"
      >
        <Box display="flex" alignItems="center" gap={3}>
          <Avatar sx={{ background: alpha(theme.palette.primary.main, 0.4) }}>
            <Flight />
          </Avatar>

          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="h5">¿Todavía sin vuelo para Miami?</Typography>
            <Typography variant="body2">Mejorá tu experiencia con las mejores ofertas de Mevuelo</Typography>

          </Box>
        </Box>

        <Button variant="contained" size="large" color="secondary" endIcon={<ChevronRight />}>Ver Ofertas</Button>

      </Box>
    </Card>
  );
};
